"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getObjectDeepKeyValue_1 = __importDefault(require("./getObjectDeepKeyValue"));
var isType_1 = require("./isType");
var filterList = function (list, by) {
    if (by === void 0) { by = ""; }
    return list.filter(function (item, idx) {
        if ((0, isType_1.isString)(by) && ((0, isType_1.isObject)(item) || (0, isType_1.isArray)(item))) {
            return (0, getObjectDeepKeyValue_1.default)(item, by);
        }
        if ((0, isType_1.isFunction)(by)) {
            return by(item, idx);
        }
        return true;
    });
};
exports.default = filterList;
//# sourceMappingURL=filterList.js.map